/**
 * Two interfaces over one app, as the customer-facing product does it.
 *
 * The classic pages keep their paths; the redesigned ones live under `/v2`.
 * Switching is the same page in the other interface, so the path travels with
 * you rather than dropping you back at the dashboard.
 */

export const V2_BASE = '/v2';
export const DEFAULT_DASHBOARD_PATH = `${V2_BASE}/dashboard`;
const V2_ONLY = [`${V2_BASE}/support-issues`, `${V2_BASE}/contact-requests`];

/** Is this path being served by the redesigned interface? */
export const isModernPath = (pathname: string) => pathname === V2_BASE || pathname.startsWith(`${V2_BASE}/`);

/** The redesigned version of wherever you are. */
export function toModernPath(pathname: string, search = '', hash = '') {
  if (isModernPath(pathname)) return `${pathname}${search}${hash}`;
  const path = pathname === '/' ? V2_BASE : `${V2_BASE}${pathname}`;
  return `${path}${search}${hash}`;
}

/** The classic version of wherever you are. */
export function toClassicPath(pathname: string, search = '', hash = '') {
  if (!isModernPath(pathname)) return `${pathname}${search}${hash}`;
  // Support and contact management are V2-only; classic has no equivalent destination.
  if (V2_ONLY.some((base) => pathname === base || pathname.startsWith(`${base}/`))) return '/dashboard';
  const path = pathname.slice(V2_BASE.length) || '/';
  return `${path}${search}${hash}`;
}
